export const docTypes = {
  BEMM: 'Body & Equipment Mounting Manual (BEMM)',
  SVO: 'Convertor Resources',
  NEWSLETTER: 'Convertor Newsletters',
  RVTTG: 'RV & Trailer Towing Guide',
  BAG: 'Body Application Guide',
  PMG: 'Police Modifier Guide',
  PMB: 'Police Modifier Bulletin',
  SVEB: 'SVE Bulletin',
  IVM: 'Incomplete Vehicle Manual',
  BBLB: 'Body Builder Layout Book',
  VS: 'Vehicle Specifications',
  WN: "What's New",
  CAD: 'CAD',
  SWG: 'SWG',
};

export const superscriptMap = {
  '0': '⁰',
  '1': '¹',
  '2': '²',
  '3': '³',
  '4': '⁴',
  '5': '⁵',
  '6': '⁶',
  '7': '⁷',
  '8': '⁸',
  '9': '⁹',
  a: 'ᵃ',
  b: 'ᵇ',
  c: 'ᶜ',
  d: 'ᵈ',
  e: 'ᵉ',
  f: 'ᶠ',
  g: 'ᵍ',
  h: 'ʰ',
  i: 'ⁱ',
  j: 'ʲ',
  k: 'ᵏ',
  l: 'ˡ',
  m: 'ᵐ',
  n: 'ⁿ',
  o: 'ᵒ',
  p: 'ᵖ',
  r: 'ʳ',
  s: 'ˢ',
  t: 'ᵗ',
  u: 'ᵘ',
  v: 'ᵛ',
  w: 'ʷ',
  x: 'ˣ',
  y: 'ʸ',
  z: 'ᶻ',
  A: 'ᴬ',
  B: 'ᴮ',
  C: 'ᶜ',
  D: 'ᴰ',
  E: 'ᴱ',
  F: 'ᶠ',
  G: 'ᴳ',
  H: 'ᴴ',
  I: 'ᴵ',
  J: 'ᴶ',
  K: 'ᴷ',
  L: 'ᴸ',
  M: 'ᴹ',
  N: 'ᴺ',
  O: 'ᴼ',
  P: 'ᴾ',
  R: 'ᴿ',
  S: 'ˢ',
  T: 'ᵀ',
  U: 'ᵁ',
  V: 'ⱽ',
  W: 'ᵂ',
  X: 'ˣ',
  Y: 'ʸ',
  Z: 'ᶻ',
};

export const CAD_REQUEST_TYPE = 'cad';
export const GENERAL_REQUEST_TYPE = 'general';

export const PTAG_REMOVAL_REGEX = /<\/?p>/g;
export const UTAG_REMOVAL_REGEX = /<\/?u>/g;
export const ALL_HTML_TAGS_REMOVAL_REGEX = /(<([^>]+)>)/gi;
export const LINK_BEFORE_AFTER_REGEX = /^(.*?)<a.*?>.*?<\/a>(.*?)$/;
export const ALL_ANCHOR_REGEX = /(<a[^>]*>.*?<\/a>)/g;
export const EN_US_MARKET = 'en-us';
export const COMMA = ', ';
export const COLOR_CODE_LINK = '#0564d7';
export const ACCORDION_ARIA_LABEL = 'Click to open the accordion';
export const EMAIL_REGEX = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$';
